import { Component, OnInit } from '@angular/core';
import { PdaPagamento } from '../../../models/pda-pagamenti';
import { PdaDownloadAvvisoRequest } from '../../../models/pda-download-avviso-request';
import { GestionePagamentiService } from '../../../services/gestione-pagamenti.service';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { PdaDownloadRicevutaRequest } from '../../../models/pda-download-ricevuta-request';
import { PdaAuthService } from 'src/app/pda/utils/Service/pda-auth.service';

@Component({
  selector: 'app-pagamenti-detail',
  templateUrl: './pagamenti-detail.component.html',
  styleUrls: ['./pagamenti-detail.component.css']
})
export class PagamentiDetailComponent implements OnInit {

  pagamento: PdaPagamento;

  constructor(private pagamentiService: GestionePagamentiService,
    private dialogRef: DialogRef,
    private dialogConfig: DialogConfig,
    private pdaAuthService: PdaAuthService
  ){

  }

  ngOnInit(): void{
    this.pagamento = this.dialogConfig.data.pagamento;
  }

  hasRicevuta(){
    return !!this.pagamento.dataRicevuta;
  }

  async onDownloadAvviso(){
    let req: PdaDownloadAvvisoRequest = new PdaDownloadAvvisoRequest();
    req.numeroAvviso = this.pagamento.numeroAvviso;
    req.token = await this.pdaAuthService.getPdaToken();
    this.pagamentiService.downloadAvviso(req).subscribe();
  }

  onDownloadRicevuta(tipo: string){
    let req: PdaDownloadRicevutaRequest = new PdaDownloadRicevutaRequest();
    if(tipo == "XML"){
      req.codiceCRS = this.pagamento.codiceCRS;
      req.copiaOriginale = true;
      req.tipo = tipo;
    } else if(tipo == "PDF"){
      req.idPagamento = this.pagamento.id;
      req.bollo = true;
      req.tipo = tipo;
    }
    this.pagamentiService.downloadRicevuta(req).subscribe();
  }

}
